import Basic from './basic.jsx';
import Error from './error.jsx';

const TextExports = {
  Basic,
  Error,
};
export default TextExports;
